<template>
  <van-pull-refresh v-model="isLoading" @refresh="onSubmit">
    <div class="recipes">
      <div class="morning">
        <div class="heading" style="padding-top: 5px">
          <van-row type="flex" align="center">
            <van-col span="4">
              <img src="../../assets/0.png" alt="" />
            </van-col>
            <van-col span="20">
              <van-row>
                <van-col span="24"> {{ stuName }}，你好 </van-col>
              </van-row>
              <van-row style="margin-top: 5px">
                <van-col span="24" style="color: #909399; font-size: 14px">
                  {{ schoolName }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{
                    classInfoLast
                  }}
                </van-col>
              </van-row>
            </van-col>
          </van-row>
        </div>
      </div>
      <!-- <van-button type="primary" @click="queryStr">查询食谱</van-button> -->
      <!-- 搜索 -->
      <div class="navbar">
        <p
          style="
            text-align: center;
            background-color: #4aaca2;
            padding: 10px 0px 10px 0px;
            color: #ffffff;
          "
        >
          {{ dateRange }}
        </p>
        <!-- <van-search v-model="value" placeholder="请输入搜索关键词" /> -->
      </div>
      <div class="weeks">
        <van-tabs
          v-model="active"
          animated
          title-active-color="#27B59C"
          color="#27B59C"
        >
          <van-tab title="周一">
            <food-list :weekFoodList="foodsList.week1" />
          </van-tab>
          <van-tab title="周二">
            <food-list :weekFoodList="foodsList.week2" />
          </van-tab>
          <van-tab title="周三">
            <food-list :weekFoodList="foodsList.week3" />
          </van-tab>
          <van-tab title="周四">
            <food-list :weekFoodList="foodsList.week4" />
          </van-tab>
          <van-tab title="周五">
            <food-list :weekFoodList="foodsList.week5" />
          </van-tab>
          <div v-if="isshowsat">
            <van-tab title="周六">
              <food-list :weekFoodList="foodsList.week6" />
            </van-tab>
          </div>
          <div v-if="isshowsun">
            <van-tab title="周日">
              <food-list :weekFoodList="foodsList.week7" />
            </van-tab>
          </div>
        </van-tabs>
      </div>
      <!-- 底部foot -->
      <div class="duration">
        <div class="asking">
          <div class="asking1" @click="forced">请假</div>
        </div>
        <div class="forgiven"></div>
        <div class="before">
          <div class="before1" @click="toComment">评价</div>
        </div>
      </div>
    </div>
  </van-pull-refresh>
</template>

<script>
// import "@/styles/movie.css";
import { Notify } from "vant";
import { Toast } from "vant";
import foodList from "@/views/foods/children/FoodList.vue";
import { dateFormat, getMonday } from "@/util/date.js";
import { weekforfoods } from "@/api/queryRecipes.js";

export default {
  components: {
    foodList,
  },
  computed: {
    dateRange: function () {
      let dayNum = parseInt(this.recipeDay, 10);
      dayNum--;
      var startDate = dateFormat(new Date(this.startTime), "yyyy-MM-dd");
      var endDateMillisec =
        new Date(this.startTime).getTime() + 1000 * 60 * 60 * 24 * dayNum;
      var endDate = new Date(endDateMillisec);
      endDate = dateFormat(endDate, "yyyy-MM-dd");
      console.log(dayNum);
      console.log(endDate);
      return startDate + " 至 " + endDate;
    },
  },
  data() {
    return {
      value: "",
      active: new Date().getDay() != 0 ? new Date().getDay() - 1 : 6,
      foodsList: {
        week1: [],
        week2: [],
        week3: [],
        week4: [],
        week5: [],
        week6: [],
        week7: [],
      },
      recipeDay: 5,
      isshowsat: false,
      isshowsun: false,
      stuName: "",
      classInfoLast: "",
      startTime: new Date(),
      schoolName: "",
      isLoading: false,
    };
  },
  created() {
    this.onSubmit();
  },
  mounted() {
    this.startTime = getMonday();
    this.recipeDay = sessionStorage.recipeDay;
    this.stuName = sessionStorage.stuName;
    this.classInfoLast = sessionStorage.classInfoLast;
    this.schoolName = sessionStorage.schoolName;
    this.isshowsat = this.recipeDay > 5;
    this.isshowsun = this.recipeDay > 6;
  },
  methods: {
    forced() {
      this.$router.push({ path: "/leaveInfo" });
    },
    toComment() {
      var isFoodsList = false;
      for (let k in this.foodsList) {
        if (this.foodsList[k].length > 0) {
          isFoodsList = true;
          break;
        }
      }
      if (isFoodsList) {
        this.$router.push({ path: "/comment" });
      } else {
        Toast("当前暂无食谱可以评论");
      }
    },
    onSubmit() {
      var params = {
        classId: sessionStorage.classId,
        name: sessionStorage.stuName,
        childNo: sessionStorage.childNo,
        classInfoLast: sessionStorage.classInfoLast,
      };
      this.axios({
        url: "api/blade-food/recipe/getRecipeList",
        method: "post",
        data: params,
      })
        .then((res) => {
          this.isLoading = false;
          // if (res.data.data.recipeCycles) {
          //   var val = res.data.data.recipeCycles;
          //   this.foodsList = weekforfoods(val);
          // }
          if (res.data.data.recipeCycles) {
            var val = res.data.data.recipeCycles;
            this.foodsList = weekforfoods(val);
            this.recipeDay = res.data.data.recipeDay;
            sessionStorage.tenantId = res.data.data.tenantId;
            sessionStorage.studentId = res.data.data.studentId;
            sessionStorage.recipeId = res.data.data.recipeCycles[0].recipeId;
          }
          sessionStorage.recipeDay = this.recipeDay;
          sessionStorage.schoolName = this.schoolName;
          this.isshowsat = this.recipeDay > 5;
          this.isshowsun = this.recipeDay > 6;
        })
        .catch((err) => {
          this.isLoading = false;
          console.log(err);
          if (err.response.data.msg) {
            Notify({ type: "warning", message: err.response.data.msg });
          }
        });
    },

    onClickRight() {
      Toast("按钮");
    },
  },
};
</script>

<style scoped>
@import "../../styles/movie.css";
</style>
